import { createContext } from 'react';

const marcaContext = createContext();

export default marcaContext;